<template>
  <div class="content">
    <div class="hover-content">
      <div class="hover-box">
        <!-- <p class="hover-title">一、单认证办理时间及材料说明</p>
        <div class="hover-desc">
          <p>1、省外办单认证：平件为受理文书后4个工作日完成（受理当日不算）；急件为受理文书后2个工作日完成（受理当日不算）；</p>
          <p>2、代办外交部单认证：以外交部认证完毕寄回时间为准；</p>
          <p>3、使领馆认证时间受多种因素影响，故本表所列认证所需时间仅供参考。</p>
        </div>
        <p class="hover-title">二、双认证办理时间及材料说明</p>
        <div class="hover-desc">
          <p>1、省外办双认证：省外办单认证时间+外国驻华领馆办证所需时间（以领事馆认证完毕寄回时间为准）；</p>
          <p>2、代办外交部双认证：外交部单认证时间+外国驻华使馆办证所需时间（以外交部、大使馆认证完毕寄回时间为准）；</p>
          <p>3、使领馆认证时间及材料受多种因素影响，故本表所列认证所需时间仅供参考。</p>
        </div>
        <p class="hover-title">三、各国使领馆办理时间及所需材料明细</p> -->
        <div v-html="MaterialList"></div>
        <a-input-search class="a-input" placeholder="请输入国家名称" size="large" @search="(e) => this.getMaterial(e)">
          <a-button slot="enterButton" type="primary">
            <a-icon type="search" />搜索
          </a-button>
        </a-input-search>

        <a-table style="margin-top: 11px;white-space: pre-wrap;font-family:'Microsoft YaHei';" :dataSource="list" :pagination="false" bordered>
          <a-table-column title="国家" dataIndex="countryName" key="countryName" width="247px">
          </a-table-column>

          <a-table-column title="所需材料" dataIndex="materialNeeded" key="materialNeeded" width="610px">
          </a-table-column>

          <a-table-column title="所需时间(天）" dataIndex="timeNeeded" key="timeNeeded" width="147px">
          </a-table-column>
        </a-table>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getMaterial, // 搜索国家
  getMaterialList // 认证材料
} from '@/api/consularCertification'
export default {
  name: 'middle-content',
  data () {
    return {
      name: '',
      list: [],
      MaterialList: ''
    }
  },
  created () {
    this.getMaterial()
    this.getMaterialList()
  },
  methods: {
    getMaterial (name) {
      getMaterial(name).then(res => {
        console.log(res);
        this.list = this._.get(res, 'data.records', [])
      })
    },
    getMaterialList () {
      getMaterialList().then(res => {
        console.log(res);
        this.MaterialList = res.data.contentHtml
      })
    }
  }
}
</script>

<style scoped lang='less'>
/deep/ .ant-btn:hover {
  color: #decba4;
  background-color: #fff;
  border-color: #decba4;
}
/deep/ .ant-btn:focus {
  color: #decba4;
  background-color: #fff;
  border-color: #decba4;
}
/deep/ .ant-table-tbody > tr > td {
  padding: 0;
}
/deep/.ant-input:focus {
  outline: none;
  box-shadow: none !important;
}
.fire-box:not(:last-of-type) {
  border-bottom: 1px solid #e5e5e5;
}
.content {
  width: 100%;
  position: relative;
  margin-bottom: 40px;
  margin-top: 59px;
  &-box {
    width: 1140px;
    position: relative;
    left: 50%;
    transform: translateX(-50%);
    text-align: left;
    font-size: 0px;
  }
}
.box:not(:last-of-type) {
  margin-right: 27px;
}
.box:hover {
  border: 1px solid #decba4;
  box-shadow: 0px 0px 20px 4px rgba(222, 203, 164, 0.32);
}
.box {
  width: 264px;
  height: 260px;
  display: inline-block;
  border: 1px solid #e5e5e5;
  box-shadow: 1px 2px 7px 1px rgba(0, 0, 0, 0.04);
  text-align: center;
  cursor: pointer;
  position: relative;
  img {
    width: 64px;
    height: 64px;
    margin-top: 61px;
  }
  p {
    margin: 0;
    padding: 0;
    font-size: 20px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #000000;
    margin-top: 23px;
  }
  .p:hover {
    color: #cbb486;
  }
  .p {
    margin-top: 22px;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #7f7f7f;

    span {
      color: #7f7f7f;
    }
    span:hover {
      color: #cbb486;
    }
  }
}
.hover-content {
  width: 1140px;
  /* height: 394px; */
  display: flex;
  justify-content: space-between;
  //padding: 48px;
  //border: 1px solid #DECBA4;
  //box-shadow: 0px 0px 20px 4px rgba(222, 203, 164, 0.32);
}
.hover-box {
  flex: 1;
  text-align: left;
  p {
    padding: 0;
    margin: 0;
    padding-bottom: 15px;
  }
  div:hover {
    color: #cbb486;
  }
  div:hover .down-btn {
    display: inline-block;
  }
  .boxx {
    margin: 0;
    padding: 0;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #3d4652;
    line-height: 68px;
    border-bottom: 1px solid #eee;
    padding-left: 15px;
    position: relative;
    white-space: nowrap;
    .down-btn {
      line-height: 36px;
      color: #cbb486;
    }
    img {
      line-height: 36px;
      margin-top: 0px;
    }
  }
  .boxx::before {
    content: "";
    display: inline-block;
    border-radius: 50%;
    width: 5px;
    height: 5px;
    background: rgba(203, 180, 134, 1);
    position: absolute;
    left: -1px;
    top: 31px;
  }
  .retrieval {
    width: 100%;
    margin-top: 20px;
    display: flex;
    span {
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #7f7f7f;
      line-height: 28px;
      vertical-align: middle;
    }
    .retrieval-content {
      display: inline-block;
      width: auto;
      padding: 0 15px;
      height: 32px;
      vertical-align: middle;
      text-align: center;
      span {
        color: #3a3a3a;
      }
    }
    .retrieval-content:hover {
      background: #cbb486;
      color: #ffffff;
      span {
        color: #ffffff;
      }
    }
  }
}
.hover-box:first-of-type {
  margin-right: 40px;
}
.down-btn {
  display: inline-block;
  display: none;
  width: 100px;
  height: 40px;
  border-radius: 20px;
  background: #ffffff;
  border: 1px solid #cbb486;
  vertical-align: middle;
  text-align: center;
  img {
    width: 16px;
    height: 16px;
  }
}
.more {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #cab484;
  /* position: absolute; */
  bottom: 56px;
  left: 50%;
  transform: translateX(-50%);
}
.hover-title {
  font-size: 20px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #1d1d1f;
}
.hover-desc {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  p {
    color: rgba(61, 70, 82, 1);
    font-size: 16px;
  }
}
.hover-content {
  .hover-address {
    color: rgba(61, 70, 82, 1);
    font-size: 16px;
    padding-top: 15px;
    span {
      color: rgba(24, 144, 255, 1);
    }
  }
}

.a-input {
  width: 520px;
  /deep/.ant-input-group-addon,
  /deep/.ant-btn {
    width: 120px;
    height: 40px;
    background: #cbb486;
    border-radius: 0px 4px 4px 0px;
    border-color: #cbb486;
  }
  /deep/.ant-input {
    width: 400px;
    height: 40px;
    background: #ffffff;
    border: 1px solid #cbb486;
    border-radius: 4px 0px 0px 4px;
  }
}
.a-table-c {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #1d1d1f;
}
</style>
<style scoped lang='less'>
.content-item {
  margin: 2px 0 0 -15px;
  width: 1142px;
  .item-content {
    margin-top: 20px;
    margin-right: 15px;
    margin-left: 15px;
    width: 505px;
    min-height: 170px;
    height: auto;
    background: #ffffff;
    border: 1px solid #e5e5e5;
    display: inline-block;
    .item-title {
      height: 18px;
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #3a3a3a;
      line-height: 28px;
    }
    .item-left {
      width: 61px;
      height: 44px;
      margin-right: 6px;
    }
    .item-right {
      width: 234px;
      height: 64px;
    }
    .item-left p,
    .item-right p {
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #7f7f7f;
      display: inline-block;
      vertical-align: middle;
      margin-bottom: -10px;
    }
  }
  .item-content:hover {
    border: 1px solid #cdad7f;
    box-shadow: 0px 0px 20px 4px rgba(222, 203, 164, 0.32);
  }
}
/deep/.ant-pagination-disabled,
.ant-pagination-disabled:hover,
.ant-pagination-disabled:focus {
  cursor: not-allowed;
  display: none;
}
/deep/.ant-pagination-item-active a {
  color: #ffffff;
  background-color: #cbb486;
}
/deep/.ant-pagination-item-active {
  border-color: #cbb486;
}
/deep/.ant-pagination a:hover {
  color: #cbb486;
}
/deep/.ant-pagination li:hover {
  border-color: #cbb486;
}
.img-list {
  display: block;
  margin-bottom: 20px;
  padding: 0;
  img {
    width: 800px;
    height: auto;
    display: block;
    margin: 0 auto;
    padding: 0;
  }
}
/deep/ .ant-table-placeholder {
  height: 100px;
}
/deep/ .ant-empty-normal {
  margin: 12px 0;
}
.type-af::after {
  content: "";
  display: inline-block;
  width: 1px;
  height: 55px;
  background: #e5e5e5;
  position: absolute;
  top: 1px;
  right: 163px;
}
// 选中行颜色变化
/deep/
  .ant-table
  .ant-table-tbody
  > tr:hover:not(.ant-table-expanded-row)
  > td {
  color: white;
  background-color: rgb(203, 180, 134);
}
</style>



// WEBPACK FOOTER //
// src/components/home/selfComponents/youjicailiao.vue